<app-bread-crumb [items]="[{text:'parcerias'}]" [sectionTitle]="'Lista de Parcerias'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <ng-box [boxIcon]="'fa fa-link'" [boxTitle]="'Parcerias'">

        <ng-container class="ng-box-header">
          <ng-button 
          *ngIf="isAdmin()" 
          (click)="create()"
          [button]="{name:'nova parceria', faIconClass:'fa fa-plus',color:'danger'}">
        </ng-button>
        </ng-container>

        <ng-container class="ng-box-content">

          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let partnership of objects;index" ngChangeColorOnHover>

              <td>{{partnership.namePartner}}</td>
              <td *ngIf="isAdminOrUserKhuzela()">{{partnership.nameClub}}</td>
              <td>{{partnership.nameService}}</td>
              <td>{{partnership.destription}}</td>


              <!-- controles -->
              <ng-actions-table-bar>
                <ng-button  *ngIf="isAdmin()" title="Editar" (click)="edit(partnership)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>
                <ng-button *ngIf="isAll()" title="Detalhe" (click)="detail(partnership)"
                  [button]="{faIconClass:'fa fa-eye',color:'danger'}"></ng-button>
                <ng-button *ngIf="isAdmin()" title="Excluir" (click)="delete(partnership)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>
              </ng-actions-table-bar>

            </tr>

          </ng-table>

          <!-- fim tabela -->
          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>
        </ng-container>

      </ng-box>
    </div>
  </div>
</section>